export default __webpack_public_path__ + "static/media/ic_videocam.f6fa75b9.svg";